//Update the videoTimeStampLocation to "left" for positioning the timestamp on the left side, or "right" for positioning it on the right side of the video.
export const videoTimeStampLocation = "left";
